<template>
  <div
    class="c-searchForm"
    :class="{ '-is-active': isDrawerActive || isPC }"
  >
    <SearchCategoryModal
      :is-modal-active="isModalActive"
      :modalCategory="modalCategory"
      :conditionsCategories="conditions.masterCategoriesList"
      @close="isModalActive = false"
      @change="setCategoryFromModal($event)"
    />
    <VerticalDrawer
      :is-active="isDrawerActive"
      :disabled="!isSP"
      direction="top"
      @close="isDrawerActive = false"
    >
      <div
        class="c-searchForm_drawer"
        @click="toggleDrawerActive"
      >
        <span class="c-searchForm_drawerText">
          {{ drawerText }}&nbsp;
          <CoconalaIcon name="chevron-up" />
        </span>
      </div>
      <div
        class="c-searchForm_inner"
        slot="drawer"
      >
        <div class="c-searchForm_title">検索条件を絞り込む</div>
        <div
          class="c-formGroup"
          ref="form"
        >
          <div class="c-formGroup_item">
            <label class="c-formGroup_itemLabel">カテゴリで絞り込む</label>
            <SearchCategory
              @click="isModalActive = true"
              v-model="categoryId"
              :categoryId="categoryId"
              :categoryTitle="categoryTitle"
              :modalCategory="modalCategory"
              :categories="conditions.masterCategoriesList"
              :isLoading="isLoading"
              @change="attributes.categoryId = $event.categoryId"
            />
          </div>
          <div class="c-formGroup_item">
            <label class="c-formGroup_itemLabel">予算で絞り込む</label>
            <div class="c-search-budget">
              <div class="c-search-budget-item">
                <SearchBudget
                  v-model="budgetMin"
                  :prices="pricesMin"
                />
              </div>
              <div class="c-search-budget-item -range">
                <span>〜</span>
              </div>
              <div class="c-search-budget-item">
                <SearchBudget
                  v-model="budgetMax"
                  :prices="pricesMax"
                />
              </div>
            </div>
          </div>
          <div class="c-formGroup_item">
            <label class="c-formGroup_itemLabel">条件で絞り込む</label>
            <SearchBudgetDefined v-model="attributes.budgetDefined" />
            <SearchRecruiting 
              v-model="attributes.recruiting"
              @input="setRecruitingCookie"
            />
          </div>
        </div>
      </div>
    </VerticalDrawer>
  </div>
</template>
<script>
import VerticalDrawer from '~/components/molecules/VerticalDrawer'

// local components
import SearchKeyword from './components/SearchKeyword'
import SearchCategory from './components/SearchCategory'
import SearchCategoryModal from './components/SearchCategoryModal'
import SearchBudget from './components/SearchBudget'
import SearchBudgetDefined from './components/SearchBudgetDefined'
import SearchRecruiting from './components/SearchRecruiting'

// vuex
import { mapState, mapGetters } from 'vuex'

// modules
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import { REQUESTS_RECRUITING } from '~/constants/cookie'

const requestSearchForm = {
  name: 'RequestSearchForm',
  components: {
    SearchKeyword,
    SearchCategory,
    SearchCategoryModal,
    SearchBudget,
    SearchBudgetDefined,
    SearchRecruiting,
    VerticalDrawer
  },
  props: {
    keyword: {
      type: String
    },
    queries: {
      type: Object
    },
    categoryId: {
      type: [String, Number],
      default: null
    },
    categoryTitle: {
      type: String,
      default: null
    },
    conditions: {
      type: Object,
      default() {}
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      attributes: this.getMergedAttributes(this.queries),
      isModalActive: false,
      isDrawerActive: false,
      isChangedAttributes: false,
      isLockAttributes: false,
      innerValueMin: null,
      innerValueMax: null,
      pricesMin: [],
      pricesMax: [],
      modalCategory: {
        id: null,
        name: '',
        parentCategoryId: null
      }
    }
  },
  methods: {
    getMergedAttributes(newValue = {}, type = '') {
      const _newValue = JSON.parse(JSON.stringify(newValue))
      this.$delete(_newValue, 'keyword')
      this.$delete(_newValue, 'sortType')
      let attributes = {
        categoryId: this.$route.query.categoryId,
        budgetDefined: null,
        recruiting: null,
        priceMin: null,
        priceMax: null
      }
      if (!type) {
        return Object.assign(attributes, _newValue)
      }
      this.attributes = Object.assign(attributes, _newValue)
    },
    toggleDrawerActive() {
      if (!this.isDrawerActive) {
        this.modalCategory.id = this.categoryId
        this.modalCategory.name = this.categoryTitle
        if (this.categoryId) {
          this.modalCategory.parentCategoryId = this.conditions.masterCategoriesList[0].id
        }
      }
      this.isDrawerActive = !this.isDrawerActive
    },
    setCategoryFromModal(event) {
      if (event.selectedCategory && event.selectedCategory.id) {
        this.attributes.categoryId = event.selectedCategory.id
        this.modalCategory = {
          id: event.selectedCategory.id,
          name: event.selectedCategory.name,
          parentCategoryId: event.parentCategoryId
        }
      } else {
        this.attributes.categoryId = null
        this.modalCategory = {
          id: null,
          name: '',
          parentCategoryId: null
        }
      }
      this.resetBudgetIfNeeded()
      this.updatePricesMax()
      this.updatePricesMin()
    },
    resetBudgetIfNeeded() {
      const { priceMin, priceMax } = this.attributes
      if (priceMin && priceMin < this.categoryLowestPrice) {
        this.attributes.priceMin = null
      }
      if (priceMax && priceMax <= this.categoryLowestPrice) {
        this.attributes.priceMax = null
      }
    },
    updatePricesMin() {
      // 予算の下限選択項目フィルタ(カテゴリの最低価格以上かつ選択中の予算上限未満)
      const budgetMax = this.budgetMax || Number.MAX_SAFE_INTEGER
      this.pricesMin = this.requestPrices.filter(p => {
        return this.categoryLowestPrice <= p && p < budgetMax
      })
    },
    updatePricesMax() {
      // 予算の上限選択項目(下限の最低額より大きいかつ選択中の予算下限より大きい)
      const minRequestPrice = Math.min(...this.requestPrices)
      const budgetMin = Math.max(this.budgetMin || 0, this.categoryLowestPrice, minRequestPrice)
      this.pricesMax = this.requestPrices.filter(p => {
        return budgetMin < p
      })
    },
    setRecruitingCookie(value) {
      this.$cookies.set(REQUESTS_RECRUITING, value)
    }
  },
  watch: {
    isDrawerActive(v) {
      if (!v && this.isChangedAttributes) {
        this.isChangedAttributes = false
        this.$emit('change', this.attributes)
      }
      if (v) {
        this.$nextTick(() => {
          this.$refs.form.scrollTop = 0
          disableBodyScroll(this.$refs.form)
        })
      } else {
        enableBodyScroll(this.$refs.form)
      }
    },
    queries: {
      deep: true,
      handler(after, before) {
        if (before.recruiting !== after.recruiting) {
          this.getMergedAttributes(after, 'change')
        }
      }
    },
    attributes: {
      deep: true,
      handler(v) {
        if (this.isLockAttributes) return
        this.isChangedAttributes = true
        if (this.isSP) return
        this.$emit('change', v)
      }
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    ...mapState('master', ['requestPrices']),
    ...mapGetters('master', ['flattenMasterCategories']),
    drawerText() {
      return this.isDrawerActive ? '結果を表示する' : '絞り込み条件を変更する'
    },
    categoryLowestPrice() {
      const masterCategory = this.flattenMasterCategories.find(
        masterCategory => masterCategory.id === Number(this.attributes.categoryId)
      )
      if (!masterCategory) {
        return 0
      }
      // カテゴリのサービス出品最低価格以下のrequestPricesの中で最大の値が公開依頼の最低価格
      return Math.max(...this.requestPrices.filter(rp => rp <= masterCategory.lowestPrice))
    },
    budgetMax: {
      get() {
        return this.attributes.priceMax
      },
      set(value) {
        this.attributes.priceMax = value
        this.updatePricesMin()
      }
    },
    budgetMin: {
      get() {
        return this.attributes.priceMin
      },
      set(value) {
        this.attributes.priceMin = value
        this.updatePricesMax()
      }
    }
  },
  created() {
    this.budgetMin = this.$route.query.priceMin ? Number(this.$route.query.priceMin) : null
    this.budgetMax = this.$route.query.priceMax ? Number(this.$route.query.priceMax) : null

    const masterCategoryId = this.$route.params.categoryId
    if (masterCategoryId) {
      this.attributes.categoryId = masterCategoryId
      this.updatePricesMax()
      this.updatePricesMin()
    }
  }
}

export default requestSearchForm
</script>
<style lang="scss" scoped>
.c-searchForm {
  user-select: none;

  &_inner {
    width: 100%;
    background-color: $color-white;
  }

  &_title {
    display: none;
  }

  &_drawer {
    display: none;
  }

  @media (max-width: breakpoint(Requests, S)) {
    $drawer-height: 48px;
    $drawer-padding: 16px;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: z(bottom-drawer, wrapper);

    &_inner {
      display: flex;
      flex-direction: column;
      border: 0;
      transition: bottom 0.2s ease;
      border-radius: 5px;

      .c-formGroup {
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }
    }

    &_title {
      display: block;
      padding: 8px 0 4px;
      border-bottom: 1px solid $color-gray-300;
      color: $color-gray-800;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
    }

    &_drawer {
      display: block;
      width: 100%;
      border: 1px solid $color-gray-300;
      background-color: $color-white;
      color: $color-blue-500;
      text-align: center;
      font-weight: bold;
      font-size: 13px;
      line-height: $drawer-height;
      padding-bottom: $drawer-padding;
      transition: background-color 0.2s ease-in-out;
      user-select: none;
    }

    &_drawerText {
      .-chevron-up {
        display: inline-block;
        vertical-align: -1px;
        font-size: 12px;
        transition: transform 0.2s ease;
      }
    }

    &.-is-active {
      .c-searchForm_drawer {
        background-color: $color-gray-50;
      }
      .c-searchForm_drawerText {
        .-chevron-up {
          transform: rotateX(180deg);
          transform-origin: left 6px;
        }
      }
    }
  }
}

/deep/ .c-verticalDrawer_drawer {
  border-radius: 10px 10px 0 0;
}

.c-formGroup {
  padding: 0;

  @media (max-width: breakpoint(Requests, S)) {
    padding: 16px;
  }

  &_item {
    padding-bottom: 12px;

    @media (max-width: breakpoint(Requests, S)) {
      padding-bottom: 0;
    }

    .c-search-budget {
      display: flex;
      justify-content: space-between;

      &-item {
        flex-basis: calc((100% - 24px) / 2);
        &.-range {
          flex-basis: 24px;
          text-align: center;

          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    &:last-child {
      border-bottom: 1px solid $color-gray-300;

      @media (max-width: breakpoint(Requests, S)) {
        border: none;
      }
    }
  }
  &_itemLabel {
    display: block;
    margin-bottom: 4px;
    color: $color-gray-900;
    font-size: 14px;
    border-top: 1px solid $color-gray-300;
    padding-top: 12px;

    @media (max-width: breakpoint(Requests, S)) {
      color: $color-gray-600;
      font-weight: bold;
      border: none;
    }
  }
}
</style>
